import ReactGA from "react-ga4";
import { config } from "../app.config";
import Member from "../types/Member";
import ApiService from "./ApiService";
import StorageService from "./StorageService";

export default class AuthService {
  static async login(email: string, password: string) {
    return await ApiService.fetch("login", { method: "POST", body: { email, password } }).then((user) => {
      if (!user.api_token) {
        return Promise.reject({ message: "The server was unable to process your login request. Please try again later" });
      }

      if (!user.member) {
        return Promise.reject({
          code: 404,
          message: "The email address or password you entered is incorrect",
          errors: {
            email: "Your account was not found. If you think this is an error, please contact " + config.contact.email + ".",
          },
        });
      }

      StorageService.set({ key: "api_token", value: user.api_token });
      StorageService.set({ key: "loggedIn", value: "true" });

      window.dispatchEvent(
        new CustomEvent("loggedIn", {
          detail: {
            member: Member.fromArray(user.member),
          },
        }),
      );

      ApiService.setApiToken(user.api_token);

      ReactGA.event({
        category: "user",
        action: "login",
        label: process.env.REACT_APP_ENVIRONMENT,
      });

      return user;
    });
  }

  static logout() {
    return Promise.all([StorageService.remove({ key: "api_token" }), StorageService.remove({ key: "user" }), StorageService.set({ key: "loggedIn", value: "false" })]).catch((err) =>
      console.error(err),
    );
  }
}
